import { TableCell } from "@mui/material"
import type { FC } from "react"

import { type InventoryPalletTableSort, InventoryPalletTableSortLabel } from "./InventoryPalletTableSortLabel"

import { InventoryPalletGroupsSortField } from "@/graphql/codegen/graphql"

interface InventoryPalletTableHeaderCellsProps {
  sort?: InventoryPalletTableSort
  showQoh?: boolean
}

export const InventoryPalletTableHeaderCells: FC<InventoryPalletTableHeaderCellsProps> = ({ sort, showQoh = true }) => (
  <>
    <TableCell className='min-w-[100px] whitespace-nowrap'>
      {sort ? (
        <InventoryPalletTableSortLabel
          field={InventoryPalletGroupsSortField.ReferenceNbr}
          label='Reference #'
          sort={sort}
        />
      ) : (
        "Reference #"
      )}
    </TableCell>
    <TableCell className='min-w-[90px] whitespace-nowrap'>
      {sort ? (
        <InventoryPalletTableSortLabel field={InventoryPalletGroupsSortField.Location} label='Location' sort={sort} />
      ) : (
        "Location"
      )}
    </TableCell>
    {showQoh && (
      <TableCell className='min-w-[80px] whitespace-nowrap'>
        {sort ? (
          <InventoryPalletTableSortLabel
            field={InventoryPalletGroupsSortField.TotalQoh}
            label='Total QoH'
            sort={sort}
          />
        ) : (
          "Total QoH"
        )}
      </TableCell>
    )}
  </>
)
